import Vue from 'vue';
import checkoutModule from '../store/checkout';
import {eventManager} from '@breakmedia/prime-vue-event-manager';

const order = {
    createOrder(address, email) {
        const basket = Vue.$basket.getConvertedLocalBasket();
        return Vue.$store.dispatch('Checkout/createOrder', {
            basket,
            address,
            email,
        });
    },
    getOrder(newOrder = false, address = null, email = null) {
        if (newOrder || !Vue.$store.state.Checkout.order) {
            return this.createOrder(address, email);
        } else if (Vue.$store.state.Checkout.order) {
            return Promise.resolve(Vue.$store.state.Checkout.order);
        }
    },
    getDeliveryCountry() {
        if (Vue.$store.state.CheckoutAddressStep && Vue.$store.state.CheckoutAddressStep.otherAddress) {
            return Vue.$store.state.ShippingAddressForm ? Vue.$store.state.ShippingAddressForm.address.country : null;
        } else {
            return Vue.$store.state.BillingAddressForm ? Vue.$store.state.BillingAddressForm.address.country : null;
        }
    },
    getBillingAddress() {
        return Vue.$store.state.BillingAddressForm.address;
    },
    getShippingAddress() {
        if (
            Vue.$store.state.CheckoutAddressStep &&
            Vue.$store.state.CheckoutAddressStep.otherAddress &&
            Vue.$store.state.ShippingAddressForm
        ) {
            return Vue.$store.state.ShippingAddressForm.address;
        } else if (Vue.$store.state.BillingAddressForm) {
            return Vue.$store.state.BillingAddressForm.address;
        }
    },
    getShippingAddresses() {
        if (
            Vue.$store.state.CheckoutAddressStep &&
            Vue.$store.state.CheckoutAddressStep.otherAddress &&
            Vue.$store.state.ShippingAddressForm
        ) {
            return Vue.$store.state.ShippingAddressForm.addresses;
        } else if (Vue.$store.state.BillingAddressForm) {
            return [Vue.$store.state.BillingAddressForm.address];
        }
    },
    getShippingAddressString: address => {
        const result = [];
        result.push(`${address.firstName} ${address.lastName}`);
        result.push(address.street || '');
        result.push(`${address.postCode} ${address.city}`);
        result.push(Vue.$language.translate(Vue.$country.getCountryNameBy('iso_2', address.country)) || '');
        return result.join(', ');
    },
    clearOrder() {
        Vue.$store.commit('Checkout/setOrder', null);
    },
    getOrderByFilters(filters) {
        return Vue.$store.dispatch('Checkout/getOrderByFilters', filters);
    },
    getExcludedPaymentTypes() {
        const result = new Set();
        Object.values(Vue.$store.state.Basket.products).forEach(product => {
            if (product.hasOwnProperty('excludedPaymentTypes')) {
                for (const excludedPaymentTypes of Object.values(product.excludedPaymentTypes)) {
                    excludedPaymentTypes.forEach(excludedPaymentType => {
                        result.add(excludedPaymentType);
                    });
                }
            }
        });
        return [...result];
    },
    isShippingAddressDifferent() {
        return Vue.$store.state.CheckoutAddressStep ? Vue.$store.state.CheckoutAddressStep.otherAddress : false;
    },
};

export default {
    install: function(Vue) {
        if (!Vue.$store.state['Checkout']) {
            Vue.$store.registerModule('Checkout', checkoutModule);
        }
        Vue.prototype.$order = order;
        Vue.$order = order;
        Vue.$store.watch(order.getDeliveryCountry, val => {
            Vue.$currency.setSelected(Vue.$country.getCountryCurrency(val), true);
        });

        eventManager.$on('purchase', order.clearOrder);
    },
};
